import React from 'react'
import { styled } from '@creditas/stylitas'
import { Typography } from '@creditas/typography'
import { Card, CardDisabled } from 'shared/ui'

export const CustomCardDisabled = styled(props => <CardDisabled {...props} />)`
  &:nth-of-type(1) {
    border-bottom: 0;
  }
  p {
    margin-right: 9px;
  }
  svg {
    position: relative;
    right: unset;
  }
`

export const CustomCard = styled(props => <Card {...props} />)`
  &:nth-of-type(1) {
    border-bottom: 0;
  }
  svg {
    transition: 0.3s;
    position: absolute;
    right: 8vw;
  }
  &:hover {
    svg {
      position: absolute;
      right: calc(8vw + -12px);
    }
  }
`

export const CardContainer = styled.div`
  height: 100px;
  border-top: 1px solid ${({ theme }) => theme.bColorNeutral10};
  border-bottom: 1px solid ${({ theme }) => theme.bColorNeutral10};
  padding: 20px 3vw;

  @media screen and (min-width: 1300px) {
    height: 130px;
    padding: 32px 7vw;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.bColorNeutral90};
  font-weight: 400;
  font-size: 20px;
  text-decoration: none;
`

export const Subtitle = styled(Typography)`
  color: ${({ theme }) => theme.bColorNeutral60};
  font-weight: 400;
  font-size: 16px;
`

export const LinkStyle = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`
